import { all } from "redux-saga/effects";
import LoginSaga from "./sagas/LoginSaga";
import assetSaga from "./sagas/AssetSaga";
import LayoutSaga from "./sagas/LayoutSaga";
import DeviceSaga from "./sagas/DeviceSaga";
import DeviceTypeSaga from "./sagas/DeviceTypeSaga";
import TranslationSaga from "./sagas/TranslationSaga";
// import UseCaseSaga from "./sagas/UseCaseSaga"

export default function* rootSaga() {
  yield all([LoginSaga(), LayoutSaga(), assetSaga(), DeviceSaga(), DeviceTypeSaga(), TranslationSaga()]);
}
